var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-utl-nkning_white';
                    var viewUrl = 'gfx/sprite.svg#view-icon-utl-nkning_white';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 19',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };